import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { Ausentismos } from '../../../../models/ausentismos';
import { AusentismosService } from '../../../../services/ausentismos.service';
import { AusentismosDetalleComponent } from '../ausentismos-detalle/ausentismos-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ausentismos-cab',
  templateUrl: './ausentismos-cab.component.html',
  styleUrls: ['./ausentismos-cab.component.css']
})
export class AusentismosCabComponent implements OnInit {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  ausentismo: Ausentismos;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  ausentismoHistoryList: any;
  ausentismosList: Ausentismos[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  ausentismos: Ausentismos[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  ausentismosInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildAusentismoDetalle') ausentismoDetalle: AusentismosDetalleComponent;

  constructor(private ausentismoService: AusentismosService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerAusentismos(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Ausentismos")) this.permisoEdicion = true;
  }

  obtenerAusentismos(agrupar)
  {
    this.buscando = true;
    this.ausentismoService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.ausentismos = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(ausentismo)
  {
    if (ausentismo.id != 0)
    {
      this.obtenerHistorial(ausentismo);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.ausentismo = ausentismo;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.ausentismo))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.ausentismoService.eliminar(this.ausentismo.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let ausentismo = this.ausentismosList.filter(d => d.id != this.ausentismo.id)[0];
              if (ausentismo == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(ausentismo);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.ausentismo))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.ausentismoDetalle.form.controls['desde'].disable();
        $this.ausentismoDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let ausenti = this.ausentismosList.find(d => d.id == index);
    this.ausentismo = ausenti;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.ausentismoDetalle.setearForm(this.ausentismo);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.ausentismoDetalle.form.getRawValue();

      let datosAus: Ausentismos = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseAusentismo: formulario.claseAusentismo,
        cantidad: formulario.cantidad,
        codigoNomina: formulario.codigoNomina,
        consumoContingente: formulario.consumoContingente,
        unidadTiempo: formulario.unidadTiempo,
        horaDesde: formulario.horaDesde,
        horaHasta: formulario.horaHasta
      };

      this.ausentismoService.guardar(datosAus).subscribe(
        ausentismo =>
        {
          ausentismo.desde = this.momentService.convertDateServer(ausentismo.desde);
          ausentismo.hasta = this.momentService.convertDateServer(ausentismo.hasta);
          
          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Ausentismo guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(ausentismo);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          this.ausentismoDetalle.setearForm(ausentismo);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.ausentismoDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.ausentismoDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.ausentismoHistoryList = [];
    this.ausentismosList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerAusentismos(false);
  }

  private obtenerHistorial(ausentismo: Ausentismos)
  {
    this.ausentismoService.getHistoryByClase(ausentismo.personal, ausentismo.claseAusentismo).subscribe(
      ausentismos =>
      {
        ausentismos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.ausentismoHistoryList = [];
        ausentismos.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.ausentismoHistoryList.push(item);
        });

        this.ausentismosList = ausentismos;
        this.verDetalle = true;
        this.ausentismo = ausentismo;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.ausentismoDetalle.form.get("desde").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.ausentismoDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.ausentismoDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }
    
    let canti = this.ausentismoDetalle.form.get("cantidad").value;
    let unida = this.ausentismoDetalle.form.get("unidadTiempo").value;
    if (canti <= 0)
    {
      if (unida == 2)
      {
        this.ausentismoDetalle.form.get("cantidad").setErrors({'sinCalendario': true });
      } else
      {
        this.ausentismoDetalle.form.get("cantidad").setErrors({'cantidadCero': true });
      }
    }
    
    if (this.ausentismoDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.ausentismoDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
}
